import { PicklistOption } from "./PicklistField.types";

/** A frozen enum from `js/enums` as picklist options: its name is the label. */
export const enumToOptions = (
  list: Record<string, string | number>
): PicklistOption[] =>
  Object.entries(list).map(([Value, Key]) => ({ Key, Value }));
